/**
 * Central design token file for the WeightPlanner Pro UI color system.
 *
 * All colors in the application should reference this file.
 * To retheme the entire app, edit values here.
 */

export const brand = {
  background: {
    primary: "#0B0F14",   // blue-black app background (dashboard, sprints, settings, etc.)
    landing: "#000000",   // pure black — landing / marketing screen only
    card: "#111827",      // charcoal navy — cards, modals, panels
    elevated: "#1F2937",  // slate navy — raised controls, dropdowns, elevated surfaces
  },

  border: {
    subtle: "rgba(255,255,255,0.08)",
    strong: "rgba(255,255,255,0.16)",
  },

  accent: {
    primary: "#3B82F6",   // electric blue — primary in-app buttons, toggles, selected tabs, focus states
    brand: "#84CC16",     // lime green — logo, landing CTA, success-oriented brand moments
  },

  text: {
    primary: "#FFFFFF",
    secondary: "rgba(255,255,255,0.7)",
    muted: "rgba(255,255,255,0.45)",
  },

  state: {
    success: "#22C55E",   // ahead / synced / imported / success
    warning: "#F59E0B",   // late / caution / attention
    danger: "#EF4444",    // destructive actions / error states
  },

  avatar: {
    fallbackBackground: "#5B7C99", // muted slate-blue for initials badge (non-status)
    fallbackText: "#FFFFFF",
  },

  chart: {
    actual: "#FFFFFF",    // actual weight line
    trend: "#60A5FA",     // trend / sky-blue
    plan: "#A78BFA",      // plan / target line
    bulk: "#F59E0B",      // bulk phase / alternate accent
  },

  shadow: {
    card: "0 8px 24px rgba(0,0,0,0.35)",
  },
} as const;
